import type { ICampaignProduct } from '../types';
import { create } from 'zustand';

export interface CampaignProductStore {
  campaignProducts: ICampaignProduct[];
  setCampaignProducts: (campaignProducts: ICampaignProduct[]) => void;
  findCampaignProductById: (id?: ICampaignProduct['id']) => ICampaignProduct | undefined;
  appendCampaignProducts: (newCampaignProducts: ICampaignProduct[]) => void;
}

export const useCampaignProductStore = create<CampaignProductStore>()((set, get) => ({
  campaignProducts: [],
  setCampaignProducts: (campaignProducts) => set({ campaignProducts }),
  findCampaignProductById: (id) => {
    if (!id) return;

    const campaignProducts = get().campaignProducts;
    return campaignProducts ? campaignProducts.find((c) => c.id === id) : undefined;
  },
  appendCampaignProducts: (newCampaignProducts) =>
    set((state) => ({
      campaignProducts: [...state.campaignProducts, ...newCampaignProducts],
    })),
}));
